import type { GettextInterface } from '../../I18n';

import { SalaryType } from './SalaryType';

export const getPayTypesToLabels = (gt: GettextInterface) => {
    return {
        [SalaryType.Hourly]: gt.pgettext('Pay selector value', 'per hour'),
        [SalaryType.Daily]: gt.pgettext('Pay selector value', 'per day'),
        [SalaryType.Weekly]: gt.pgettext('Pay selector value', 'per week'),
        [SalaryType.Monthly]: gt.pgettext('Pay selector value', 'per month'),
        [SalaryType.Yearly]: gt.pgettext('Pay selector value', 'per year'),
    };
};
